module.exports = __webpack_public_path__ + "img/login_gsnd.d65a3d12.svg";